let templateContent = '';
let templateId = '';
export const setTemplateContent = (content, id = '') => {
    templateContent = content;
    templateId = id;
};
export const getTemplateContent = (needId) => {
    if (needId) {
        return {
            templateContent,
            templateId,
        };
    }
    return templateContent;
};
